import { useMutation } from '@tanstack/react-query'
import { z } from 'zod'

import { client } from '../../../services/client'
import { makeServerResponseSchema } from '../../../utils/schema'
import { unlayerDesignSchema } from '../unlayer.schema'

type CreateAIUnlayerDesignInputs = {
  productIds?: Array<string>
  prompt: string
  templateId: string
}

async function createAIUnlayerDesign({
  productIds,
  prompt,
  templateId,
}: CreateAIUnlayerDesignInputs) {
  const response = await client
    .extend({ timeout: 180000 }) // 3 minute timeout
    .post('functions/unlayerDesignAI', {
      json: {
        productIds,
        prompt,
        templateId,
      },
    })
    .json()

  const parsedResponse = makeServerResponseSchema(
    z.object({ unlayerDesign: unlayerDesignSchema })
  ).safeParse(response)

  if (!parsedResponse.success)
    throw new Error(
      `Something went wrong generating your email template. ${parsedResponse.error.message}`
    )
  return parsedResponse.data.result
}

function useCreateAIUnlayerDesign() {
  return useMutation({
    mutationFn: createAIUnlayerDesign,
  })
}

export { useCreateAIUnlayerDesign }
